import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileInput } from '@app/profile/profile';

@Component({
  selector: 'dgx-profile-not-found',
  templateUrl: './profile-not-found.component.html',
  styleUrls: ['./profile-not-found.component.scss'],
})
export class ProfileNotFoundComponent implements OnInit {
  constructor(
    @Inject('profileInput') private profileInput: ProfileInput,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.router.navigateByUrl(
      `/profile/${this.profileInput.profile.vanityUrl}`,
      { replaceUrl: true }
    );
  }
}
